import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import BoldText from 'components/BoldText';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import FrameCsvExportButton from 'features/Frames/components/Frames/FramesTable/components/FrameCsvExportButton';

import useStyles from './SearchPageTableHeader.styles';

type SearchPageTableHeaderProps = {
  searchTerm: string | null;
  numberOfResults: number;
};

const SearchPageTableHeader = ({ searchTerm, numberOfResults }: SearchPageTableHeaderProps) => {
  const classes = useStyles();

  const { searchParams } = useSearchParamsProvider();

  return (
    <Box className={classes.header}>
      <Typography variant="body1" fontWeight={400}>
        {<BoldText text={`${numberOfResults}`} />} results for "{searchTerm}"
      </Typography>
      <FrameCsvExportButton searchParams={searchParams} />
    </Box>
  );
};

export default SearchPageTableHeader;
